<style scoped>
.percent-icon {
	height: 30px;
	padding: 0 6px;
	background: #fff;
	line-height: 30px;
}
</style>


<template>
	<section>
		<compWrapper title="基本信息" theme="primary">
			<vForm :label-width="110" inline class="margin-layout" ref="formdata">
				<vFormItem label="发运港" class="width-50per" prop="shipPortCode" required>
					<vSelect v-model="formData.shipPortCode">
						<vOption v-for="item in getPortList" :key="item" :value="item">{{item}}</vOption>
					</vSelect>
				</vFormItem>
				<vFormItem label="集装箱型" class="width-50per">
					<vSelect v-model="formData.packingType">
						<vOption v-for="item in getCarTypeList" :key="item" :value="item">{{item}}</vOption>
					</vSelect>
				</vFormItem>
				<vFormItem label="SKU" class="width-50per">
					<vInput v-model="formData.sku" readonly suffix="search" @on-icon-click="handleModal"></vInput>
				</vFormItem>
				<vFormItem label="SKU整柜装箱量" class="width-50per" prop="packingAmount" required>
					<vInputNumber clearable v-model="formData.packingAmount" :min="1" math="round"></vInputNumber>
				</vFormItem>
				<div class="width-50per inline-block">
					<vFormItem label="单品尺寸" prop="length" required>
						<vInputNumber
							style="width:85px;"
							clearable
							v-model="formData.length"
							:min="0.001"
							placeholder="长"
						></vInputNumber>
					</vFormItem>
					<vFormItem label :label-width="15" prop="width" required>
						<vInputNumber
							style="width:85px;"
							clearable
							v-model="formData.width"
							:min="0.001"
							placeholder="宽"
						></vInputNumber>
					</vFormItem>
					<vFormItem label :label-width="15" prop="height" required>
						<vInputNumber
							style="width:85px;"
							clearable
							v-model="formData.height"
							:min="0.001"
							placeholder="高"
						></vInputNumber>
					</vFormItem>
					<vFormItem label :label-width="15">
						<vSelect v-model="formData.lengthUnit" style="width:62px;">
							<vOption v-for="item in getLenUnitList" :key="item" :value="item">{{item}}</vOption>
						</vSelect>
					</vFormItem>
				</div>
				<div class="width-50per inline-block">
					<vFormItem label="单品重量" prop="weight" required class="width-70per">
						<vInputNumber clearable v-model="formData.weight" :min="0.001" placeholder="重量"></vInputNumber>
					</vFormItem>
					<vFormItem label :label-width="20">
						<vSelect v-model="formData.weightUnit" style="width:90px;">
							<vOption v-for="item in getWeightUnitList" :key="item" :value="item">{{item}}</vOption>
						</vSelect>
					</vFormItem>
				</div>
				<div style="padding:10px 0 20px 46px;">
					<span class="color-error">*</span> 备货方案（填写各仓备货比例，比例之和需=100%),
				</div>
				<vFormItem
					:label-width="120"
					label="Los Angeles 1号仓"
					class="width-30per"
					style="margin-left:37px;"
				>
					<vInputNumber style="width:120px" clearable v-model="formData.HF_CA_US" :min="0.001">
						<div slot="append" class="percent-icon">%</div>
					</vInputNumber>
				</vFormItem>
				<vFormItem label="Indiana 1号仓" class="width-30per">
					<vInputNumber style="width:120px" clearable v-model="formData.CTG_US_IN" :min="0.001">
						<div slot="append" class="percent-icon">%</div>
					</vInputNumber>
				</vFormItem>
				<vFormItem label="Atlanta 1号仓">
					<vInputNumber style="width:120px" clearable v-model="formData.Midwest_GA_US" :min="0.001">
						<div slot="append" class="percent-icon">%</div>
					</vInputNumber>
				</vFormItem>
			</vForm>
			<vButtonGroup class="text-center">
				<vButton theme="primary" @click="calc">测 算</vButton>
				<vButton @click="reset">重 置</vButton>
			</vButtonGroup>
		</compWrapper>
		<compWrapper title="测算结果（币种USD）" theme="primary" v-if="fbaDataList">
			<div class="absolute" style="right:10px;top:2px;">
				<vButton theme="success" @click="print">打 印</vButton>
			</div>
			<div class="margin-layout">
				<div class="padding-10 font-bold">FBA</div>
				<vTableSimple :data="fbaDataList" border :columns="getFbaColumns"></vTableSimple>
			</div>
			<div class="margin-layout">
				<div class="padding-10 font-bold">Onsite</div>
				<vTableSimple :data="onSiteDataList" border :columns="getOnsiteColumns"></vTableSimple>
			</div>
			<div class="margin-layout">
				<div class="padding-10 font-bold">FBM</div>
				<vTableSimple :data="fbmDataList" border :columns="getFbmColumns"></vTableSimple>
			</div>
			<div class="margin-left-50 padding-10 font-bold font-14">
				<p style="margin-left:-36px">说明：1. 此费用为单位SKU的全程物流成本</p>
				<p>2. 整柜进仓备货数量请填写SKU的40 HQ的装柜装箱数量</p>
				<p>
					3. Monthly的仓储堆存费：FBA分为淡旺季堆存费；Onstie为各个仓库固定单位CBM堆存费；FBM / SFP分为免仓期 / 健康
					库存（90天以内）/ 不健康库存（超过90天）等情况下的月度仓储成本
				</p>
				<p>4. 头程费用不包含关税等不可控及其他在港口可能会产生的费用，FBA的头程费用请自行计算</p>
				<p>5. 综合处理费包括入库、库内的操作及拣货下架等费用，其中FBM / SFP的尾程费用已经按Zone分别显示，并已包含住宅地址附加费</p>
				<p>
					6. FBM / SFP的尾程派送可能产生的附加费包括偏远住宅地址 / 超偏远住宅地址 / 商业地址 / 偏远商业地址 / 超偏远商业地
					址 / 更址附加费6种，其中前5种只会产生一种，不会同时产生
				</p>
				<p>7. 各项费用的最终解释权归Cope所有。</p>
			</div>
		</compWrapper>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				:is="modalProps.component"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
				v-bind="modalProps.props"
			></component>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>
<script>

import { HttpChargescalcCost } from "@/service/chargescalc";
import { mapGetters } from "vuex"
import compSkuList from "@/components/skulist"
export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
		compModal: () => import("@components/templates/modal"),
		compSkuList,
	},
	data() {
		return {
			loading: false,
			fbaDataList: null,
			onsiteDataList: null,
			fbmDataList: null,
			modalProps: {
				show: false,
			},
			formData: {
				// organizationId: global.SYSID,
				lengthUnit: "inch",
				weightUnit: "lbs",
				shipPortCode: "",
				useSfp: 0,
				packingType: "40HQ"
			}
		}
	},
	created() {

	},
	computed: {
		...mapGetters(['getAuthUserOrgId']),
		...mapGetters("common", ["getLenUnitList", "getWeightUnitList"]),
		getPortList() {
			return ["宁波港", "上海港", "深圳港"]
		},
		getCarTypeList() {
			return ["40HQ"]
		},

		getFbaColumns() {
			return [{
				title: "头程费/Pcs",
				key: "headCost"
			}, {
				title: "仓储费/Pcs/月",
				// key: ",
				children: [
					{
						title: "淡季",
						key: "slackSeasonRate"
					},
					{
						title: "旺季",
						key: "busySeasonRate"
					}
				]
			}, {
				title: "综合处理费/Pcs",
				key: "comprehensiveProcessingCost"
			}]
		},
		getOnsiteColumns() {
			return [{
				title: "头程费/Pcs",
				key: "headCost"
			}, {
				title: "仓储费/Pcs/月",
				key: "storageCost",
			}, {
				title: "综合处理费/Pcs",
				key: "comprehensiveProcessingCost"
			}]
		},
		getFbmColumns() {
			return [{
				title: "头程费/Pcs",
				key: "headCost"
			}, {
				title: "仓储费/Pcs/月",
				// key: "cartonBarcode",
				children: [
					{
						title: "免仓期",
						key: "noHealthCost"
					},
					{
						title: "健康库存",
						key: "healthCost"
					},
					{
						title: "非健康库存",
						key: "unHealthCost"
					},
				]
			}, {
				title: "综合处理费/Pcs",
				// key: "cartonBarcode",
				children: [
					{
						title: "Zone2",
						key: "2"
					},
					{
						title: "Zone3",
						key: "3"
					},
					{
						title: "Zone4",
						key: "4"
					},
					{
						title: "Zone5",
						key: "5"
					},
					{
						title: "Zone6",
						key: "6"
					},
					{
						title: "Zone7",
						key: "7"
					},
					{
						title: "Zone8",
						key: "8"
					},
				]
			}]
		}

	},
	methods: {
		// 查找sku
		handleModal() {
			this.modalProps = {
				show: true,
				width: 1000,
				title: " 查找SKU",
				component: "compSkuList",
				showFooter: false,
				props: {
					startUp: true,
				},
				on: {
					"on-data": (row) => {
						const { length, width, height, weight, lengthUnit, weightUnit, sku } = row;
						this.formData = {
							...this.formData,
							length, width, height, weight, sku,
							lengthUnit: this.getLenUnitList[lengthUnit],
							weightUnit: this.getWeightUnitList[weightUnit],
						};
						this.modalProps = {};
					}
				}
			}
		},
		handlePercent(val) {
			return parseFloat((val || 0) / 100).toFixed(4)
		},
		// handlePercentTotal(val) {
		// 	console.log(arguments)
		// },
		// 测算
		async calc() {
			const valid = await this.$refs.formdata.validate();
			if (!valid) return;
			const { Midwest_GA_US, HF_CA_US, CTG_US_IN } = this.formData;
			const total = parseFloat(Midwest_GA_US || 0) + parseFloat(HF_CA_US || 0) + parseFloat(CTG_US_IN || 0);
			if (parseFloat(total).toFixed(3) - 100 != 0) {
				this.$VMessage.warning("各仓备货比例，比例之和需=100%");
				return
			}
			const formData = {
				...this.formData,
				stockingPlan: {
					Midwest_GA_US: this.handlePercent(Midwest_GA_US),
					HF_CA_US: this.handlePercent(HF_CA_US),
					CTG_US_IN: this.handlePercent(CTG_US_IN),
				},
				organizationId: this.getAuthUserOrgId
			}
			delete formData.Midwest_GA_US;
			delete formData.HF_CA_US;
			delete formData.CTG_US_IN;
			this.loading = true;
			HttpChargescalcCost(formData).then(res => {
				const { FBA, FBM, OnSite } = res.data || {};
				this.loading = false;
				this.fbaDataList = [{
					...FBA.storageCost,
					...FBA.comprehensiveProcessingCost,
					headCost: "请自行计算"
				}]
				this.onSiteDataList = [{
					...OnSite.storageCost,
					...OnSite.headCost,
					...OnSite.comprehensiveProcessingCost,
				}]
				this.fbmDataList = [{
					...FBM.storageCost,
					...FBM.headCost,
					...FBM.comprehensiveProcessingCost,
					noHealthCost: 0
				}]
			}).catch(err => {
				this.fbaDataList = this.onSiteDataList = this.fbmDataList = null;
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		reset() {
			this.$refs.formdata.resetValidate();
			this.formData = {
				lengthUnit: "inch",
				weightUnit: "lbs",
				useSfp: 0,
			}
			this.fbaDataList = this.onSiteDataList = this.fbmDataList = null;
		},
		print() {

		}
	},
}
</script>
